<template>
  <div class="page claim-page">
    <h2 class="page-title">泉井认领</h2>
    <div class="filter-card">
      <el-form :model="query" size="small" label-width="68px" class="filter-form">
        <el-row :gutter="12">
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24"><el-form-item label="泉井名称"><el-input v-model="query.wellName" placeholder="搜索泉井名称" clearable /></el-form-item></el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24"><el-form-item label="认领人"><el-input v-model="query.realName" placeholder="认领人姓名" clearable /></el-form-item></el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24"><el-form-item label="申请人"><el-input v-model="query.keyword" placeholder="昵称/电话" clearable /></el-form-item></el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="审核状态">
              <el-select v-model="query.status" clearable placeholder="全部">
                <el-option label="待审核" :value="0" /><el-option label="已通过" :value="1" /><el-option label="已拒绝" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12" :sm="24" :xs="24">
            <el-form-item label="时间范围">
              <el-date-picker
                v-model="query.dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item class="filter-actions">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
              <el-button @click="exportList">导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-card">
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="wellName" label="泉井名称" min-width="160" show-overflow-tooltip />
        <el-table-column label="申请用户" min-width="180">
          <template slot-scope="scope">
            <div class="user-cell">
              <el-avatar :size="36" :src="scope.row.avatar || scope.row.avatarUrl" icon="el-icon-user-solid" />
              <div>
                <div class="main-text">{{ scope.row.nickname || scope.row.realName || '-' }}</div>
                <div class="sub-text">{{ scope.row.phone || scope.row.userPhone || '-' }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="realName" label="认领人名称" min-width="120" show-overflow-tooltip />
        <el-table-column prop="phone" label="联系电话" min-width="130" show-overflow-tooltip />
        <el-table-column prop="reason" label="认领理由" min-width="200" show-overflow-tooltip />
        <el-table-column prop="rejectReason" label="审批备注" min-width="160" show-overflow-tooltip />
        <el-table-column label="状态" width="110">
          <template slot-scope="scope"><el-tag :type="statusType(scope.row.status)">{{ statusText(scope.row.status) }}</el-tag></template>
        </el-table-column>
        <el-table-column label="申请时间" width="170"><template slot-scope="scope">{{ formatDateTime(scope.row.createdAt) }}</template></el-table-column>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <div class="action-bar">
              <span v-if="scope.row.status === 0" class="action-text audit" @click="openAudit(scope.row)">审核</span>
              <span class="action-text delete" @click="handleDelete(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next, total" :total="total" :current-page.sync="query.pageNum" :page-size="query.pageSize" @current-change="loadData" style="margin-top:16px;text-align:right" />
    </div>

    <el-dialog title="认领审核" :visible.sync="auditVisible" width="480px">
      <el-form :model="auditForm" label-width="90px">
        <el-form-item label="泉井">{{ auditRow && auditRow.wellName }}</el-form-item>
        <el-form-item label="申请人">{{ auditRow && (auditRow.realName || auditRow.userName || auditRow.nickname) }}</el-form-item>
        <el-form-item label="认领原因">{{ auditRow && auditRow.reason }}</el-form-item>
        <el-form-item label="审核结论">
          <el-radio-group v-model="auditForm.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审批备注">
          <el-input v-model="auditForm.remark" type="textarea" :rows="3" placeholder="可填写审批备注，拒绝时请说明原因" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="auditVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAudit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchClaims, auditClaim, deleteClaim } from '@/api'

export default {
  data() {
    return {
      loading: false,
      tableData: [], total: 0,
      query: { pageNum: 1, pageSize: 10, wellName: '', realName: '', keyword: '', status: undefined, dateRange: [] },
      auditVisible: false, auditRow: null,
      auditForm: { id: null, status: 1, remark: '' }
    }
  },
  created() { this.loadData() },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = { ...this.query }
        if (params.dateRange && params.dateRange.length === 2) {
          params.startTime = params.dateRange[0]
          params.endTime = params.dateRange[1]
        }
        delete params.dateRange
        Object.keys(params).forEach(k => { if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k] })
        const res = await fetchClaims(params)
        this.tableData = res.records || []; this.total = res.total || 0
      } finally { this.loading = false }
    },
    handleSearch() { this.query.pageNum = 1; this.loadData() },
    handleReset() { this.query = { pageNum: 1, pageSize: 10, wellName: '', realName: '', keyword: '', status: undefined, dateRange: [] }; this.loadData() },
    openAudit(row) { this.auditRow = row; this.auditForm = { id: row.id, status: 1, remark: row.rejectReason || '' }; this.auditVisible = true },
    async submitAudit() {
      await auditClaim(this.auditForm)
      this.$message.success('审核已提交'); this.auditVisible = false; this.loadData()
    },
    async handleDelete(row) {
      const wellName = row.wellName || ''
      const userName = row.nickname || row.realName || '该用户'
      try {
        await this.$confirm(
          "此操作将解除【" + wellName + "】的认领关系，" + userName + " 将从守望者降为普通用户，泉井变为待认领状态。是否确认？",
          "删除并解绑确认",
          { type: 'warning', confirmButtonText: '确认删除', cancelButtonText: '取消' }
        )
        await deleteClaim(row.id)
        this.$message.success('已删除，泉井守望者已解绑')
        this.loadData()
      } catch (e) {}
    },
    exportList() {
      const h = ['ID', '泉井名称', '申请用户', '联系电话', '认领人名称', '认领理由', '审批备注', '状态', '申请时间']
      const r = this.tableData.map(row => [row.id, row.wellName, row.nickname || row.realName, row.phone || row.userPhone, row.realName, row.reason, row.rejectReason || '', this.statusText(row.status), this.formatDateTime(row.createdAt)])
      const csv = [h, ...r].map(items => items.map(v => '"' + String(v == null ? '' : v).replace(/"/g, '""') + '"').join(',')).join('\n')
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a'); link.href = URL.createObjectURL(blob); link.download = '泉井认领_' + new Date().toISOString().slice(0, 10) + '.csv'; link.click(); URL.revokeObjectURL(link.href)
    },
    formatDateTime(v) { return v ? String(v).replace('T', ' ') : '-' },
    statusText(v) { return v === 0 ? '待审核' : v === 1 ? '已通过' : v === 2 ? '已拒绝' : '未知' },
    statusType(v) { return v === 1 ? 'success' : v === 2 ? 'danger' : 'warning' }
  }
}
</script>

<style scoped>
.filter-form ::v-deep .el-row { width: 100%; }
.filter-form ::v-deep .el-form-item { margin-bottom: 12px; }
.filter-form ::v-deep .el-input, .filter-form ::v-deep .el-select { width: 100%; }
.filter-form ::v-deep .filter-actions .el-form-item__content { display: flex; gap: 8px; }
.user-cell { display: flex; align-items: center; gap: 10px; }
.main-text { color: #333; font-weight: 600; line-height: 20px; }
.sub-text { color: #909399; font-size: 12px; line-height: 18px; }
.action-bar { display: flex; align-items: center; gap: 10px; }
.action-text { cursor: pointer; font-size: 13px; }
.action-text:hover { text-decoration: underline; }
.action-text.audit { color: #2f8f5b; }
.action-text.delete { color: #f56c6c; }
</style>
